import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, Info, XCircle, type LucideIcon } from 'lucide-react';

export type AlertTone = 'info' | 'success' | 'warning' | 'error';

const config: Record<AlertTone, { icon: LucideIcon; color: string }> = {
  info: { icon: Info, color: 'var(--accent)' },
  success: { icon: CheckCircle2, color: 'var(--pill-completed-dot)' },
  warning: { icon: AlertTriangle, color: 'var(--booking-ink)' },
  error: { icon: XCircle, color: 'var(--pill-cancelled-dot)' },
};

export function Alert({
  tone = 'info',
  children,
  className = '',
}: {
  tone?: AlertTone;
  children: ReactNode;
  className?: string;
}) {
  const { icon: Icon, color } = config[tone];
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`flex items-start gap-2.5 rounded-[12px] px-4 py-3.5 text-[14.5px] leading-relaxed text-ink ${className}`}
      style={{ background: `color-mix(in srgb, ${color} 11%, transparent)` }}
    >
      <Icon size={18} strokeWidth={1.8} className="mt-px shrink-0" style={{ color }} />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
